import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DployFormControl, getFieldError, identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import { commonButtonColors, commonButtonVariants, isButtonColor, isButtonVariant } from "./ButtonCommon";
import { apiResourceUrl, getIn } from "@ploy-lib/core";
import icons from "./Icons";
import { useAppLoad } from "../../appLoadContext";
import { useSearchParams } from "react-router-dom";
import { PendingButton } from "@ploy-ui/core";
import { useCallback, useState } from "react";
import { Box, FormHelperText } from "@material-ui/core";
import { useFormikContext } from 'formik';
var GoToSblStatus;
(function (GoToSblStatus) {
    GoToSblStatus[GoToSblStatus["Failure"] = 0] = "Failure";
    GoToSblStatus[GoToSblStatus["Success"] = 1] = "Success";
    GoToSblStatus[GoToSblStatus["Completed"] = 2] = "Completed";
})(GoToSblStatus || (GoToSblStatus = {}));
export const GoToSblButton = ({ muiEndIcon, variant, color, size, action, fullWidth, margin, options: { style }, errorDisplay, disabled, buttonSize, className, field, form, label, ...props }) => {
    const appLoadData = useAppLoad();
    const [searchParams, _] = useSearchParams();
    const customerContext = searchParams.get("customerContext");
    const { submitForm } = useFormikContext();
    const { value, name } = field;
    const { errors, touched } = form;
    const errorProps = getFieldError(errors, touched, field.name, errorDisplay);
    const error = getIn(form.errors, name);
    const buttonColor = isButtonColor(color) ? color : undefined;
    const buttonVariant = isButtonVariant(variant) ? variant : undefined;
    const [internalState, setInternalState] = useState({});
    const onClick = useCallback(async (e) => {
        try {
            form.setFieldTouched(name, true);
            if (error)
                return;
            setInternalState({ loading: true, success: false });
            let goToSblUri = apiResourceUrl(`/GoToSbl/${appLoadData.applicationId}/`);
            if (customerContext) {
                goToSblUri += `?customerContext=${customerContext}`;
            }
            const response = await fetch(goToSblUri, { method: "GET" });
            if (!response.ok) {
                throw new Error("Error initiating SBL: Response from server is not OK");
            }
            const content = (await response.json());
            switch (content.Status) {
                case GoToSblStatus.Success: {
                    window.open(content.RedirectUrl, "_parent");
                    setInternalState({ loading: false, success: true });
                    break;
                }
                case GoToSblStatus.Completed: {
                    /*
                     * Submit the form if SBL is completed. This will cause a
                     * reevaluation of what form to present to the user.
                     */
                    submitForm();
                    setInternalState({ loading: false, success: true });
                    break;
                }
                default: {
                    throw new Error("Error initiating SBL: Missing SBL redirect URL");
                }
            }
        }
        catch (error) {
            console.error(error);
            setInternalState({ error: error, loading: false });
        }
    }, [form, name, error, appLoadData.applicationId, customerContext, submitForm]);
    const helperText = (internalState.success && value) ||
        (errorProps?.error && errorProps.helperText) ||
        internalState.error?.message;
    return (_jsxs(DployFormControl, { className: className, margin: margin, error: errorProps?.error || Boolean(internalState.error), fullWidth: fullWidth, children: [_jsx(PendingButton, { style: style, color: buttonColor, variant: buttonVariant, fullWidth: fullWidth, disabled: disabled || errorProps?.error, helperText: errorProps?.helperText, size: buttonSize || "large", endIcon: muiEndIcon && icons[muiEndIcon], success: internalState.success && !errorProps?.error, error: errorProps?.error || Boolean(internalState.error), onClick: onClick, children: label }), helperText && (_jsx(Box, { component: FormHelperText, textAlign: "center", color: errorProps?.error || Boolean(internalState.error)
                    ? "error.main"
                    : internalState.success
                        ? "success.main"
                        : undefined, children: helperText }))] }));
};
GoToSblButton.displayName = "GoToSblButton";
export const EditorGoToSblButton = identityRecordOfFieldEditorOptions({
    GoToSblButton: {
        editableOptions: {
            variant: commonButtonVariants,
            color: commonButtonColors,
            muiEndIcons: Object.keys(icons)
        }
    }
});
//# sourceMappingURL=GoToSblButton.js.map